import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'contactInformationTypeIcon'
})
export class ContactInformationTypeIconPipe implements PipeTransform {

  transform(value: number) {
    switch (value) {
      case 1:
        return 'alternate_email';
      case 2:
      case 3:
        return 'phone';
      case 4:
        return 'fax';
    }
    return 'more_horiz';
  }

}
